import React, { useState } from 'react'
import { capitalizeAndRemoveUnderscores, limitWords } from '../../../utils/utils';
import { Checkbox, Spin, Table, Tooltip, Space, Upload, message, Button, Popconfirm, Modal } from 'antd';
import Pnation from '../../../components/Pagination/pagination';
import CustomSearch from '../../../components/search/CustomSearch';
import HoverIcon from '../../../components/icons/HoverIcon';
import { FileDoneOutlined, FolderAddOutlined, FileExcelOutlined, CloseCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { formatIndianDate, uploadAgreementType } from "../../../utils/Constant";
import axiosInstance from '../../../utils/axiosInstance';

export default function Archive() {
  const [arcData, setArcData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState({ search_keyword: '' });
  const [isLoading, setIsloading] = useState(false);

  const [currentIndex, setCurrentIndex] = useState(0); // Track current object
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [dupData, setDupData] = useState([]); // Store API response data

  const [loadInfo, setLoadInfo] = useState({
    isLoading: false,
    type: '', // allSubmit,submit,archive,deleteFile,addFile,deleteRow,forceAdd
    id: ''
  })


  // All functions of table

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      // Select all rows
      const allRowKeys = arcData?.map((item) => item.uid);
      setSelectedRowKeys(allRowKeys);
    } else {
      // Deselect all rows
      setSelectedRowKeys([]);
    }
  };


  const props = {
    name: "file",
    multiple: false,
    accept: uploadAgreementType,
    beforeUpload(file) {
      const acceptedExt = uploadAgreementType.split(",");
      const ext = file.name.split(".").pop();
      if (!acceptedExt.includes("." + ext)) {
        message.error("You can only upload xls and xlsx files!");
        return Upload.LIST_IGNORE; // Ignore invalid files
      }
      return true;
    },
    showUploadList: false,
    onError(error) {
      message.error("An error occurred during upload. Please try again.");
    },
  };

  async function customRequest({ file, onSuccess, onError }, record, index) {
    try {
      setLoadInfo({
        isLoading: true,
        type: 'addFile',
        id: record.uid
      })
      const formData = new FormData();
      formData.append("agreement_file", file); // 🔥 File is sent under "agreement_file"
      const response = await axiosInstance.put(`/contract/archive-agreements/update-file/${record.id}/`, formData)
      if (response.status == 200) {
        onSuccess();
        message.success(response.data.message);
      } else {
        message.success(response.data.error);
        message.error("An error occurred during upload.");
      }

    } catch (error) {
      onError();
    } finally {
      setLoadInfo({
        isLoading: false,
        type: '',
        id: ''
      })
    }
  };

  const onChange = (info, index) => {
    const { status, response } = info.file;
    if (status !== "uploading") {
      // return false;
      console.log(info.file, info.fileList);
    }
    if (status === "done") {
      const arData = [...arcData];
      arData[index]["Agreement File"] = info.file.name;
      setArcData(arData)
      message.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === "error") {
      message.error(`${info.file.name} file upload failed.`);
      return false
    };
  }
  // Delete File
  const onDeleteAggrement = async (record, index) => {
    try {
      const payload = { agreement_file: '' }
      setLoadInfo({
        isLoading: true,
        type: 'deleteFile',
        id: record.uid
      })
      const response = await axiosInstance.put(`/contract/archive-agreements/update-file/${record.id}/`, payload)
      if (response.status == 200) {
        message.success(response.data.message);
        setArcData((val) => {
          val[index]["Agreement File"] = '';
          return [...val];
        })
      } else {
        message.success(response.data.error);
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoadInfo({
        isLoading: false,
        type: '',
        id: ''
      })
    }
  }

  // Delete Row
  const onDeleteRow = async (index, id, uid, type) => {
    try {
      if (!selectedRowKeys.includes(uid) && type !== 'byPass') {
        message.error('Kindly ensure the data is checked before proceeding.');
        return false;
      }
      setLoadInfo({
        isLoading: true,
        type: 'deleteRow',
        id: uid
      })
      const response = await axiosInstance.delete(`/contract/archive-agreements/delete/${id}/`)
      if (response.status == 200) {
        message.success(response.data.message);

        if (arcData.length === 1) {
          setSearchKeyword((val) => {
            return { ...val }
          })
          setSelectedRowKeys([])
        } else {
          setArcData((val) => val.filter(item => uid != item.uid))
          setSelectedRowKeys((val) => val.filter((item) => item != uid))
        }
      } else {
        message.success(response.data.error);
      }
    } catch (error) {
      console.error(error);
      message.success('There is an unidentified issue .');
    } finally {
      setLoadInfo({
        isLoading: false,
        type: '',
        id: ''
      })
    }
  }



  // send Agreement to server
  const onSentAgreement = async (id, index, type) => {
    try {
      let payload = {};
      const agrData = { ...arcData[index] };
      if (type != 'all') {
        if (!selectedRowKeys.includes(agrData.uid)) {
          message.error('Your Aggrement is Uncheck .');
          return;
        }
        if (!agrData["Agreement File"]) {
          message.error('Please upload agreement file .');
          return;
        }
        payload = { agreement_ids: id };

      } else {
        const ids = []
        arcData.filter((item) => {
          if (selectedRowKeys.includes(item.uid) && !!item["Agreement File"]) {
            ids.push(item.id)
          }
        });

        if (!ids.length) {
          message.error('Please ensure at least one agreement is checked and uploaded . ')
          return;
        }
        payload = { agreement_ids: ids }
      }

      setLoadInfo({
        isLoading: true,
        type: type == 'all' ? 'allSubmit' : 'submit',
        id: agrData.uid
      })
      const response = await axiosInstance.post(`/contract/create-bulk-data-agreements/`, payload)
      if (response.status == 200) {
        message.success(response.data.message);
        setDupData(response.data.existing_agreements);

        // if (type === 'all') {
        if (!!response.data.new_agreements.length) {
          const ids = response.data.new_agreements.map(item => item.uid);
          if (ids.length === arcData.length) {
            setSearchKeyword((val) => {
              return { ...val }
            })
          }
          setArcData((val) => val.filter((item) => !ids.includes(item.uid)));
          setSelectedRowKeys(val => val.filter((id) => response.data.new_agreements.some((sucAgr) => sucAgr.uid != id)));
        }
        if (response.data.existing_agreements.length > 0) {
          setIsModalVisible(true);
        }



      } else {
        message.success(response.data.error);
      }


    } catch (error) {
      message.success('There is an unidentified error .');
      console.log(error, 'error')
    } finally {
      setLoadInfo({
        isLoading: false,
        type: '',
        id: ''
      })
    }
  }

  const columns = [
    {
      title: (
        <Checkbox
          indeterminate={
            selectedRowKeys.length > 0 &&
            selectedRowKeys.length < arcData.length
          }
          checked={selectedRowKeys.length === arcData.length}
          onChange={handleSelectAllChange}
        />
      ),
      dataIndex: "checkbox",
      render: (_, record) => (
        <Checkbox
          checked={selectedRowKeys.includes(record.uid)}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedRowKeys([...selectedRowKeys, record.uid]);
            } else {
              setSelectedRowKeys(
                selectedRowKeys.filter((key) => key !== record.uid)
              );
            }
          }}
        />
      ),
    },
    {
      title: (
        <Tooltip className="whitespace-nowrap" title="Date of Raising (dd-mm-yyyy)">Date of Raising <br />
          (dd-mm-yyyy)</Tooltip>
      ),
      dataIndex: "Execution date",
      key: "Execution date",
      render: (date, record) => (
        <span style={{}}>
          {formatIndianDate(date)}
        </span>
      ),
    },
    {
      title: "Agreement Type",
      dataIndex: "Agreement Type",
      render: (text, record) => (
        <Tooltip title={text}>
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",

            }}
          >
            {limitWords(text, 6)}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Partner Name",
      dataIndex: "Business Entity Name",
      render: (text, record) => (
        <span >
          {text && text.charAt(0).toUpperCase() + text.slice(1)}
        </span>
      ),
    },
    {
      title: "Nature",
      dataIndex: "Nature",
      render: (text, record) => (
        <span style={{}}>
          {text && text.charAt(0).toUpperCase() + text.slice(1)}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text, record) => (
        <span style={{}}>
          {capitalizeAndRemoveUnderscores(text)}
        </span>
      ),
    },
    {
      title: <Tooltip className="whitespace-nowrap" title="Remarks(if any)">
        <span>Remarks(if any)</span>
      </Tooltip>,
      dataIndex: "Remarks",
      ellipsis: true, // Enable ellipsis for the column
      render: (text, record) => (
        <Tooltip title={text}>
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",

            }}
          >
            {limitWords(text, 6)}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Select File",
      key: "Select",
      render: (_, record, index) => (
        <Space>
          <Upload
            onChange={(info) => onChange(info, index)}
            {...props}
            customRequest={(data) => { customRequest(data, record, index) }}
          >
            <Button
              type={record["Agreement File"] ? "primary" : "default"}  // Makes it stand out
              style={record["Agreement File"] ? { color: "green", borderColor: "green" } : {}}
              icon={
                loadInfo.type == 'addFile' && loadInfo.id == record.uid ? (
                  <Spin size="small" />
                ) : record.file ? (
                  <FileDoneOutlined style={{ fontSize: "24px" }} />
                ) : (
                  <FolderAddOutlined style={{ fontSize: "24px" }} />
                )
              }
              disabled={record["Agreement File"] || loadInfo.isLoading} >
            </Button>
          </Upload>

          {record["Agreement File"] && <Tooltip title={record["Agreement File"]}> <span style={{ marginLeft: 8 }}>{limitWords(record["Agreement File"])}</span> </Tooltip>}
        </Space>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record, index) => (
        <Space>
          {/* Delete File Button */}
          <Popconfirm
            title="Are you sure to delete this file?"
            onConfirm={() => onDeleteAggrement(record, index)}
            okText="Yes"
            cancelText="No"
          >
            <HoverIcon
              icon={<FileExcelOutlined />}
              tooltip="Delete Uploaded File"
              color={!record["Agreement File"] ? "gray" : "red"}
              hoverBgColor={!record["Agreement File"] ? "transparent" : "#ffccc7"}
              onClick={() => { }}
              hoverColor={!record["Agreement File"] ? "gray" : "red"}
              disabled={!record["Agreement File"] || loadInfo.isLoading}
              isLoading={loadInfo.type == 'deleteFile' && loadInfo.id == record.uid}
            />

          </Popconfirm>

          {/* Delete Row Button */}
          <Popconfirm
            title="Are you sure to delete this row?"
            onConfirm={() => onDeleteRow(index, record.id, record.uid)}
            okText="Yes"
            cancelText="No"
          >
            <HoverIcon
              icon={<CloseCircleOutlined />}
              tooltip="Delete This Row"
              color="red"
              hoverBgColor="#ffccc7"
              onClick={() => { }}
              hoverColor="darkred"
              disabled={loadInfo.isLoading}
              isLoading={loadInfo.type == 'deleteRow' && loadInfo.id == record.uid}
            />
          </Popconfirm>

          {/* Submit Agreement Button */}
          <HoverIcon
            icon={<CheckCircleOutlined />}
            tooltip="Submit This Agreement"
            color="green"
            hoverBgColor="#d9f7be"
            disabled={loadInfo.isLoading}
            isLoading={loadInfo.type == 'submit' && loadInfo.id == record.uid}
            onClick={() => onSentAgreement(record.id, index, 'single')}
            hoverColor={"darkgreen"}
          />

        </Space>
      ),
    }
  ];


  // Pagination and search part 
  const onPeding = (val) => {
    setIsloading(val)
  }

  const getData = (data) => {
    setArcData(data);
    //To clear the select agreement data
    setSelectedRowKeys([])
  }
  const handleSearch = (value) => {
    setSearchKeyword((val) => {
      val.search_keyword = value;
      return { ...val }
    })
  };

  // Duplicate data 
  // Handle "No" button click -> Show next modal

  const handleAddNo = () => {
    // Hide 1st model
    setIsModalVisible(false);
    // Show 2nd Model
    setIsDeleteModalVisible(true);
  };

  // Handle "Yes" button click -> Call API and then show next modal
  const forcefullyAdd = async () => {
    setLoading(true);
    try {
      const uid = dupData[currentIndex]['uid'];
      const agId = dupData[currentIndex]['id'];
      delete dupData[currentIndex]['uid']; // backend said frontend should remove uid key.
      const payload = { existing_agreements: [dupData[currentIndex]] };
      setLoadInfo({
        isLoading: true,
        type: 'forceAdd',
        id: uid
      })
      const response = await axiosInstance.post(`/contract/force-create-archive-agreements/`, payload)
      if (response.status == 200) {
        message.success(response.data.message);
        setSelectedRowKeys(val => val.filter((id) => id != uid)) // To remove AGREEMENT UID  FROM SELECTED array .
        setArcData((val) => val.filter(item => uid != item.uid))
        // nextObject(); 
      } else {
        message.error("Failed to process");
      }

    } catch (error) {
      message.error(error, "API error");
    } finally {
      setLoadInfo({
        isLoading: false,
        type: '',
        id: ''
      })
      setLoading(false);
    }
  };

  // Handle "Yes" button click -> Call API and then show next modal
  const handleAddYes = async () => {
    await forcefullyAdd();
    nextObject();// Goto new model next duplicate agreement 
  };

  // Move to the next object or close modal

  const nextObject = () => {
    if (currentIndex + 1 < dupData.length) { // Check is there have any unseen agreement have or not
      setCurrentIndex(currentIndex + 1); // Goto next agreement index
      setIsDeleteModalVisible(false); // Hide 2nd Model
      setIsModalVisible(true); // Show 1st Model
    } else {  // all agreement modle are see .
      setIsModalVisible(false); // Hide 1st Model
      setIsDeleteModalVisible(false); // Hide 2nd Model
      // set initial value of duplicate states 
      setCurrentIndex(0);
      setDupData([]);

    }
  };

  // Handle "Delete Yes" button click -> Call API and then show next modal
  const handleDeleteYes = () => {
    const rowData = dupData[currentIndex];
    onDeleteRow(null, rowData.id, rowData.uid, 'byPass'); // Delete the duplicate agreement from table .
    nextObject(); // Goto next table .
  };

  // Handle "Delete No" button click -> Show next object
  const handleDeleteNo = () => {
    nextObject(); // Goto next Agreement model .
  };



  return (
    <div>
      {/* <div className="pl-4"> */}
      <div className="flex flex-row  pb-3 px-2 justify-between my-2 align-middle">
        <span>
          <h1
            className="mt-1 text-lg font-[700] text-[30px] "
          >
            Archive List
          </h1>
        </span>
        {!!arcData.length && <div className="pl-4">
          <Space>
            <CustomSearch onSearch={handleSearch} />
            <Tooltip title="Approve and Submit Checked Data">
              <Button type="primary" disabled={loadInfo.isLoading}
                loading={loadInfo.type === 'allSubmit'} onClick={() => onSentAgreement(null, null, 'all')}>
                Submit Data
              </Button>
            </Tooltip>
          </Space>
        </div>}
      </div>
      {/* </div> */}
      <div className=" border border-gray-300">
        <Spin spinning={isLoading} tip="Loading...">
          <Table
            columns={columns}
            dataSource={arcData || []}
            scroll={{ x: "max-content", y: 400 }}
            pagination={false}
          />
        </Spin>
      </div>
      <Pnation onPeding={onPeding} onCngPage={getData} url='/contract/archive-agreements/list/' plod={searchKeyword} />

      <Modal
        title="Duplicate Agreement"
        open={isModalVisible} // Use 'open' instead of 'visible'
        onCancel={() => setIsModalVisible(false)}
        footer={[
          <Button key="no" onClick={handleAddNo} disabled={loading}>
            No
          </Button>,
          <Button key="yes" type="primary" onClick={handleAddYes} loading={loading}>
            Yes
          </Button>,
        ]}
      >
        {dupData.length > 0 && (
          // <><p> This agreement is exit , Do you want to forcefully add with: <b>{dupData[currentIndex]?.name_of_client}</b>?</p>

          <p>{`The details of ( ${dupData[currentIndex]?.party}_ ${dupData[currentIndex]?.nature} ) are identical to the other Agreement with Agreement ID  ${dupData[currentIndex]?.document_id}. Would you still like to proceed?`}</p>
        )}
      </Modal>


      <Modal
        title="Delete Confirmation"
        open={isDeleteModalVisible} // Use 'open' instead of 'visible'
        onCancel={() => setIsDeleteModalVisible(false)}
        footer={[
          <Button key="no" onClick={handleDeleteNo} disabled={loading}>
            No
          </Button>,
          <Button key="yes" type="primary" danger onClick={handleDeleteYes} loading={loading}>
            Yes, Delete
          </Button>,
        ]}
      >
        <p>Do you want to delete this? </p>
      </Modal>
    </div>
  )
}
